import React, { useEffect, useState } from 'react';
import { useDocumentHelper } from '@hmhco/document-helper';
import { useIntl, FormattedMessage } from 'react-intl';
import { usePlatform } from '@hmhco/platform-helper';
import { Typography } from '@mui/material';
import { getIdentifiedPlatformClientId } from '@hmhco/login-config';
import Button from '@mui/material/Button';
import { ALERT_SIZE, HcpAlert, SEVERITY } from '@hmhco/hcp-alert';
import logErrorWithContext from '@hmhco/client-monitoring/src/context/logErrorWithContext';
import TenantPickerLayout from '../../Layout/TenantPickerLayout';
import Logo from '../../Logo/Logo';
import useStyles from './LoginMethodSelectPage.styles';
import { useLoginOptions } from '../../../../hooks/useLoginOptions';

const LoginMethodSelectPage = () => {
  const { formatMessage } = useIntl();
  const [options, setOptions] = useState([]);
  const [hasError, setHasError] = useState(false);
  const { classes } = useStyles();
  const platform = usePlatform();
  const { getLoginOptions } = useLoginOptions();

  const search = new URLSearchParams(window.location.search);

  const ariaTitle = formatMessage(
    { id: 'loginMethodSelect.title.aria' },
    { platform },
  );
  useDocumentHelper(ariaTitle);

  useEffect(() => {
    getLoginOptions(getIdentifiedPlatformClientId(), search.get('org_ref_id'))
      .then(loginOptions => {
        setOptions(loginOptions);
      })
      .catch(error => {
        setHasError(true);
        logErrorWithContext('Login Method Select', error);
      });
  }, []);

  return (
    <TenantPickerLayout>
      <header>
        <Logo />
        <div className={classes.heading}>
          <Typography component="h1" variant="h3" aria-label={ariaTitle}>
            <FormattedMessage id="loginMethodSelect.title" />
          </Typography>
        </div>
        {hasError && (
          <HcpAlert
            size={ALERT_SIZE.LARGE}
            severity={SEVERITY.ERROR}
            title={formatMessage({
              id: 'loginMethodSelect.errorTitle',
            })}
            subtitle={formatMessage({
              id: 'loginMethodSelect.errorSubtitle',
            })}
            className={classes.error}
            action={null}
          />
        )}
      </header>
      <main className={classes.main}>
        {options.map(option => (
          <Button
            size="medium"
            variant="outlined"
            key={option.name}
            href={option.login_url}
          >
            {option.name}
          </Button>
        ))}
      </main>
    </TenantPickerLayout>
  );
};

export default LoginMethodSelectPage;
